import React, { Component } from "react";
import PropTypes from "prop-types";
import TextField from "material-ui/TextField";

class TextInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value
    };
    this.onChange = this.onChange.bind(this);
  }
  onChange = (event, value) => {
    this.setState({ value: value });
    this.props.onChange(value);
  };
  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;
    if (value !== this.props.value) {
      this.setState({ value: value });
    }
  }
  render() {
    const { title, name, fullWidth } = this.props;
    return (
      <div>
        <TextField
          fullWidth={fullWidth}
          hintText=""
          name={name}
          floatingLabelText={title}
          value={this.state.value}
          onChange={this.onChange}
        />
      </div>
    );
  }
}
TextInput.propTypes = {
  value: PropTypes.string,
  title: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  fullWidth: PropTypes.bool
};

TextInput.defaultProps = {
  title: "Alternate Text",
  value: "alternatif text",
  name: "textinput",
  fullWidth: false
};
export default TextInput;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/components/TextInput.js